import { render, staticRenderFns } from "./regionSelect.vue?vue&type=template&id=60feb3a2&scoped=true&"
import script from "./regionSelect.vue?vue&type=script&lang=js&"
export * from "./regionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60feb3a2",
  null
  
)

export default component.exports